import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { Button } from '@digdir/designsystemet-react';
import classes from './AnalyzeSurveyNavigation.module.css';

type AnalyzeSurveyNavigationProps = {
  questionsTotalLength: number;
};

export const AnalyzeSurveyNavigation = ({
  questionsTotalLength,
}: AnalyzeSurveyNavigationProps) => {
  const { t } = useTranslation();
  const { teamId, surveyId, pageQuestionIndex } = useParams();
  const current = Number(pageQuestionIndex);
  const isFirst = current === 1;
  const isLast = current === questionsTotalLength;
  const basePath = `/teams/${teamId}/analyze-survey/${surveyId}`;

  return (
    <div className={classes.navigation}>
      {isFirst ? (
        <Button variant="secondary" disabled>
          {t('analysis.previous')}
        </Button>
      ) : (
        <Button asChild variant="secondary">
          <Link to={`${basePath}/${current - 1}`}>{t('analysis.previous')}</Link>
        </Button>
      )}
      <Button asChild>
        <Link to={isLast ? `${basePath}/summary` : `${basePath}/${current + 1}`}>
          {isLast ? t('analysis.toSummary') : t('analysis.nextQuestion')}
        </Link>
      </Button>
    </div>
  );
};
